export default "__VITE_ASSET__BBrCKkiq__ 100w";